<div class="main-iamge">
  <div nz-row>
    <div nz-col [nzXs]="{ span: 24,offset:0}" [nzLg]="{ span: 16,offset:4}">
      <div nz-row class="main-padding" *ngIf="showPage==1 || showPage==2">
        <div nz-col [nzXs]="{ span: 22,offset:1}" [nzLg]="{ span: 22,offset:1}">
          <!-- <p class="skip-text" (click)="onNavigateHome()">Skip</p> -->
        </div>
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 14}">
          <div nz-row class="image-padding">
            <div nz-col [nzXs]="{ span: 24,offset: 0}" [nzLg]="{ span: 20,offset: 2}">
              <img src="/assets/images/new/login-main.png" class="mobileView" style="width: 100%;" />
              <img src="/assets/images/new/login-image1.png" class="WebView" style="width: 100%;" />
            </div>
          </div>
        </div>
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 10}" *ngIf="showPage==1">
          <div nz-row class="main-padding">
            <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
              <p class="Hello">Signup or Login</p>
            </div>
            <div nz-col [nzXs]="{ span: 22,offset:1}" [nzLg]="{ span: 18,offset:0}">
              <form nz-form [formGroup]="GenerateUserOTPForm" class="login-form" class="step2-text">
                <div nz-row>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                          <ng-template #addOnBeforeTemplate>
                            <span style="margin-left: 5px;">+91</span>
                          </ng-template>
                          <input type="text" formControlName="PhoneNumber" nz-input class="input-box-width"
                            placeholder="Enter Phone Number"
                            style="width: 100%;height: 38px;border-radius: 8px;border: none;" maxlength="10"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');">
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzSpan="24" style="margin: 0.5rem 0;">
                    <div class="recaptcha-container">
                      <div class="g-recaptcha" data-sitekey="6LeVTlsmAAAAAPxze0qVmGtIgEl5t6SgK-K7tTLF"></div>
                    </div>
                  </div>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <button nz-button nzType="primary" class="verify-button" (click)="onClickLogin(2)">Send
                          OTP</button>
                      </nz-form-control>
                    </nz-form-item>
                    <p style="text-align: center;margin-top: 40px;color: #000;font-weight: 500;">By Continuing.you agree
                      to our<br />
                      <span style="color: #19baba;">Terms of policy</span> and <span style="color: #19baba;">Privacy
                        policy</span>
                    </p>
                  </div>
                </div>
              </form>

            </div>
          </div>

        </div>
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 10}" *ngIf="showPage==2">
          <p class="Hello mobileView">Verify Mobile Number</p>
          <div nz-row class="main-padding">
            <div nz-col [nzXs]="{ span: 14,offset:1}" [nzLg]="{ span: 16,offset:0}">
              <p class="Hello WebView">Verify Mobile Number</p>
              <p style="font-size: 13px;color: #ddd;">A 4 digit code sent to</p>
              <p style="font-weight: 600;color: #000;font-size: 16px;">+91 {{GenerateUserOTPForm.value.PhoneNumber}}
                <span style="color: #ee7e1a;margin-left: 20px;">Edit</span>
              </p>

            </div>
            <div nz-col [nzXs]="{ span: 8}" [nzLg]="{ span: 5}">
              <img src="/assets/images/new/login-image2.png" style="width: 100%;" />
            </div>
          </div>


          <div nz-row>
            <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 24}">
              <form nz-form [formGroup]="OTPForm" class="login-form">
                <div nz-row>
                  <div nz-col [nzXs]="{ span: 22,offset:1}" [nzSm]="{  span: 22,offset:1}"
                    [nzMd]="{  span: 22,offset:1}" [nzLg]="{  span: 22,offset:1}">
                    <nz-form-item>
                      <!-- <nz-form-label nzFor="Cluster">OTP</nz-form-label> -->
                      <nz-form-control>
                        <nz-input-group [nzSize]="'large'">
                          <div nz-row [nzGutter]="8">
                            <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 6}" [nzMd]="{ span: 6}" [nzLg]="{ span: 5}">
                              <nz-form-item>
                                <nz-form-control [nzSpan]="24">
                                  <input type="text" formControlName="Otp1" #otp1 nz-input maxlength="1" />
                                </nz-form-control>
                              </nz-form-item>

                            </div>
                            <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 6}" [nzMd]="{ span: 6}" [nzLg]="{ span: 5}">
                              <nz-form-item>
                                <nz-form-control [nzSpan]="24">
                                  <input type="text" formControlName="Otp2" #otp2 nz-input maxlength="1" />
                                </nz-form-control>
                              </nz-form-item>

                            </div>
                            <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 6}" [nzMd]="{ span: 6}" [nzLg]="{ span: 5}">
                              <nz-form-item>
                                <nz-form-control [nzSpan]="24">
                                  <input type="text" formControlName="Otp3" #otp3 nz-input maxlength="1" />
                                </nz-form-control>
                              </nz-form-item>

                            </div>
                            <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 6}" [nzMd]="{ span: 6}" [nzLg]="{ span: 5}">
                              <nz-form-item>
                                <nz-form-control [nzSpan]="24">
                                  <input type="text" formControlName="Otp4" #otp4 nz-input maxlength="1" />
                                </nz-form-control>
                              </nz-form-item>

                            </div>

                          </div>
                        </nz-input-group>

                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </form>
            </div>
            <div nz-col [nzXs]="{ span: 16,offset: 4}" [nzSm]="{span: 12,offset: 6}" [nzMd]="{ span: 12,offset: 6}"
              [nzLg]="{ span: 12,offset: 4}" style="text-align: center;">
              <p style="color: #000;" (click)="onClickLogin(3)">00:29</p>
              <p style="color: #707070;">Don’t get code <span style="color: #ee7e1a;">Resend</span></p>
              <!--  <div nz-row style="margin-top: 0px;">
          
           <div nz-col [nzXs]="{ span: 12}" [nzSm]="{span: 12}" [nzMd]="{ span: 12}" [nzLg]="{ span: 12}">
              <p class="Verify-code">Resend code</p>
            </div>
            <div nz-col [nzXs]="{ span: 10}" [nzSm]="{span: 12}" [nzMd]="{ span: 12}" [nzLg]="{ span: 12}">
              <p class="Verify-code" (click)="onClickLogin(3)">Verify code</p>
            </div> 
          </div>-->
            </div>
          </div>


        </div>
      </div>
      <div nz-row style="background: #fff;margin-top: 30px;" *ngIf="showPage==3">
        <div nz-col [nzXs]="{ span: 22,offset:1}" [nzLg]="{ span: 22,offset:1}">
          <div nz-row class="profile-padding">
            <div nz-col [nzXs]="{ span: 16}" [nzLg]="{ span: 24}">
              <p style="margin-top: 16px;
          font-size:  16px;
          font-weight: bold;"><i nz-icon nzType="left" nzTheme="outline" style="font-size: 18px;margin-right: 5px;"
                  (click)="onClickLogin(3)"></i> Profile Setup</p>
            </div>
            <div nz-col [nzXs]="{ span: 8}" [nzLg]="{ span: 24}" class="mobileView">
              <!-- <p class="skip-text" (click)="onNavigateHome()">Skip</p> -->
            </div>
          </div>
        </div>

        <div nz-col [nzXs]="{ span: 22,offset:1}" [nzLg]="{ span: 22,offset:1}">
          <div nz-row class="profile-padding">
            <!-- <div nz-col [nzXs]="{ span: 8,offset: 8}" [nzLg]="{ span: 8,offset: 8 }" style="text-align: center;">
          <img src="/assets/images/user.png" class="upload-image-setting" />
          <img src="/assets/images/cemara.png" class="cemara-padding" />
          <p class="cemara-text">Update Profile</p>
        </div> -->

            <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 11 }">
              <form nz-form [formGroup]="ProfileForm" class="login-form">
                <div nz-row>
                  <div nz-col nzSpan="24">
                    <p class="label-text">Name</p>
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <input type="text" formControlName="name" nz-input class="input-box-width"
                          placeholder="Enter name" style="width: 100%;height: 32px;border-radius: 8px">
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div nz-col nzSpan="24">
                    <p class="label-text">Mail</p>
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <input type="text" formControlName="Mail" nz-input class="input-box-width"
                          placeholder="Enter Mail ID" style="width: 100%;height: 32px;border-radius: 8px">
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 18 }">
                    <p class="label-text">Gender</p>
                    <div nz-row [nzGutter]="16">
                      <div nz-col nzSpan="8">
                        <button nz-button nzType="primary" class="verify-type"
                          [class.verifytypeSelected]="genderType==1" (click)="selecteGender(1)">Male</button>
                      </div>
                      <div nz-col nzSpan="8">
                        <button nz-button nzType="primary" class="verify-type"
                          [class.verifytypeSelected]="genderType==2" (click)="selecteGender(2)">Female</button>
                      </div>
                      <div nz-col nzSpan="8">
                        <button nz-button nzType="primary" class="verify-type"
                          [class.verifytypeSelected]="genderType==3" (click)="selecteGender(3)">Others</button>
                      </div>
                    </div>
                  </div>
                  <div nz-col nzSpan="24" style="margin-top: 20px;">
                    <p class="label-text">Date Of Birth</p>
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <nz-date-picker formControlName="date" style="width: 100%;
                  height: 32px;font-size: 18px;border-radius: 8px;"></nz-date-picker>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzSpan="24" style="margin-top: 20px;">
                    <p class="label-text">Ref PhoneNumber</p>
                    <nz-form-item>
                      <!-- <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                  <nz-date-picker formControlName="date" style="width: 100%;
                  height: 35px;font-size: 18px;border-radius: 8px;"></nz-date-picker>
                </nz-form-control> -->
                      <nz-form-control [nzSm]="24" [nzXs]="24" [nzHasFeedback]="true" [nzErrorTip]="ref_ErrorMsg"
                        [nzSuccessTip]="ref_SuccessTipTMP" [nzValidateStatus]="validationState"
                        nzErrorTip="Please input Ref Phone Number!">
                        <input nz-input formControlName="Ref_PhoneNumber" placeholder="Enter Your Ref Phone Number" />
                      </nz-form-control>
                      <ng-template #ref_SuccessTipTMP>
                        <span style="color: green;">
                          {{ref_SuccessTip}}
                        </span>
                      </ng-template>
                    </nz-form-item>
                  </div>


                  <div nz-col nzSpan="24" style="margin-top: 10px;">
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <label nz-checkbox formControlName="Whether_18_Years_Above" style="font-size: 12px;">18 Years
                          Above Years or Not</label>
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                        <label nz-checkbox formControlName="Whether_TC_Accepted" style="font-size: 12px;">A accept all
                          <span style="color:#19baba">Terms & Conditions</span> and <span style="color:#19baba">Privacy
                            policy</span></label>
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                </div>
              </form>
            </div>
            <div nz-col [nzXs]="{ span: 24,offset:0}" [nzLg]="{ span: 12,offset:1 }">
              <img src="/assets/images/new/login-image1.png" style="width: 100%;" class="WebView" />
              <div nz-row style="margin-top: 40px;">
                <div nz-col nzSpan="24" class="profile-padding">
                  <nz-form-item>
                    <nz-form-control [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
                      <button nz-button nzType="primary" class="verify-button" (click)="onClickLogin(4)">Update</button>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div nz-row *ngIf="showPage==4" class="suc-padding">
        <div nz-col [nzXs]="{ span: 22,offset: 1}" [nzLg]="{ span: 16,offset: 4}"
          style="background: #fff;padding: 20px;">
          <div nz-row clsss="Success-padding">
            <div nz-col [nzXs]="{ span: 8,offset: 8}" [nzLg]="{ span: 6,offset: 9}">
              <img src="/assets/images/Success.png" style="width: 100%;" />
            </div>
            <div nz-col [nzXs]="{ span: 20,offset: 2}" [nzLg]="{ span: 20,offset: 2}">
              <p class="Success">Success</p>
              <p class="Success-text">Your Profile Updated<br />
                successfully </p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>